import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import CheckoutPage from "./pages/CheckoutPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AccountPage from "./pages/AccountPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import RequireAuth from "./components/auth/RequireAuth";
import { ProductDataProvider } from "./context/ProductDataContext";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./components/CartContext";
import ScrollToTop from "./components/ScrollToTop";
import SmartHomeFunctionsPage from "./pages/SmartHomeFunctionsPage";
import SmartHomeBuilderPage from "./pages/SmartHomeBuilderPage";
import EcosystemsPage from "./pages/EcosystemsPage";
import FunctionLightingDetailPage from "./pages/functions/FunctionLightingDetailPage";
import FunctionCoolingHeatingDetailPage from "./pages/functions/FunctionCoolingHeatingDetailPage";
import FunctionShadingDetailPage from "./pages/functions/FunctionShadingDetailPage";
import FunctionSecurityDetailPage from "./pages/functions/FunctionSecurityDetailPage";
import FunctionMultiroomAudioDetailPage from "./pages/functions/FunctionMultiroomAudioDetailPage";
import FunctionAccessControlDetailPage from "./pages/functions/FunctionAccessControlDetailPage";
import FunctionEnergyManagementDetailPage from "./pages/functions/FunctionEnergyManagementDetailPage";
import FunctionVentilationDetailPage from "./pages/functions/FunctionVentilationDetailPage";
import FunctionPresenceSimulationDetailPage from "./pages/functions/FunctionPresenceSimulationDetailPage";
import FunctionAssistedLivingDetailPage from "./pages/functions/FunctionAssistedLivingDetailPage";
import FunctionPoolControlDetailPage from "./pages/functions/FunctionPoolControlDetailPage";
import FunctionRemoteAccessDetailPage from "./pages/functions/FunctionRemoteAccessDetailPage";
import FunctionWeatherServiceDetailPage from "./pages/functions/FunctionWeatherServiceDetailPage";
import FunctionNotificationsDetailPage from "./pages/functions/FunctionNotificationsDetailPage";
import FunctionSystemControlDetailPage from "./pages/functions/FunctionSystemControlDetailPage";
import FunctionPresenceSensingDetailPage from "./pages/functions/FunctionPresenceSensingDetailPage";
import FunctionIrrigationDetailPage from "./pages/functions/FunctionIrrigationDetailPage";
import FunctionCamerasDetailPage from "./pages/functions/FunctionCamerasDetailPage";
import FunctionEntertainmentDetailPage from "./pages/functions/FunctionEntertainmentDetailPage";
import FunctionVoiceControlDetailPage from "./pages/functions/FunctionVoiceControlDetailPage";
import FunctionGeofencingDetailPage from "./pages/functions/FunctionGeofencingDetailPage";
import NotFoundPage from "./pages/NotFoundPage";


export default function App() {
  return (
    <CartProvider>
      <AuthProvider>
      <ProductDataProvider>
        <Router>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/kategoriak" element={<CategoryPage />} />
              <Route path="/kategoriak/:categoryId" element={<CategoryPage />} />
              <Route path="/termek/:productId" element={<ProductDetailPage />} />
              <Route path="/rolunk" element={<AboutPage />} />
              <Route path="/kapcsolat" element={<ContactPage />} />
              <Route path="/megrendeles" element={<CheckoutPage />} />
              <Route path="/bejelentkezes" element={<LoginPage />} />
              <Route path="/regisztracio" element={<RegisterPage />} />
              <Route path="/jelszo-elfelejtve" element={<ForgotPasswordPage />} />
              <Route path="/jelszo-visszaallitas" element={<ResetPasswordPage />} />
              <Route path="/email-megerosites" element={<VerifyEmailPage />} />
              <Route
                path="/fiok"
                element={
                  <RequireAuth>
                    <AccountPage />
                  </RequireAuth>
                }
              />
              <Route path="/funkciok" element={<SmartHomeFunctionsPage />} />
              <Route path="/builder" element={<SmartHomeBuilderPage />} />

              <Route path="/funkciok/vilagitas" element={<FunctionLightingDetailPage />} />
              <Route path="/funkciok/hutes-futes" element={<FunctionCoolingHeatingDetailPage />} />
              <Route path="/funkciok/arnyekolas" element={<FunctionShadingDetailPage />} />
              <Route path="/funkciok/riaszto-biztonsag" element={<FunctionSecurityDetailPage />} />
              <Route path="/funkciok/multiroom-audio" element={<FunctionMultiroomAudioDetailPage />} />
              <Route path="/funkciok/belepes-vezerles" element={<FunctionAccessControlDetailPage />} />
              <Route path="/funkciok/energia-menedzsment" element={<FunctionEnergyManagementDetailPage />} />
              <Route path="/funkciok/szelloztetes" element={<FunctionVentilationDetailPage />} />
              <Route path="/funkciok/jelenlet-szimulacio" element={<FunctionPresenceSimulationDetailPage />} />
              <Route path="/funkciok/asszisztalt-elet" element={<FunctionAssistedLivingDetailPage />} />
              <Route path="/funkciok/medence-vezerles" element={<FunctionPoolControlDetailPage />} />
              <Route path="/funkciok/tavoli-hozzaferes" element={<FunctionRemoteAccessDetailPage />} />
              <Route path="/funkciok/idojaras-szolgaltatas" element={<FunctionWeatherServiceDetailPage />} />
              <Route path="/funkciok/ertesitesek" element={<FunctionNotificationsDetailPage />} />
              <Route path="/funkciok/rendszer-vezerles" element={<FunctionSystemControlDetailPage />} />
              <Route path="/funkciok/jelenlet-erzekeles" element={<FunctionPresenceSensingDetailPage />} />
              <Route path="/funkciok/kertontozes" element={<FunctionIrrigationDetailPage />} />
              <Route path="/funkciok/kamerak" element={<FunctionCamerasDetailPage />} />
              <Route path="/funkciok/szorakoztatas" element={<FunctionEntertainmentDetailPage />} />
              <Route path="/funkciok/hangvezerles" element={<FunctionVoiceControlDetailPage />} />
              <Route path="/funkciok/geofencing" element={<FunctionGeofencingDetailPage />} />

              <Route path="/okoszisztemak" element={<EcosystemsPage />} />

              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
        </Router>
      </ProductDataProvider>
      </AuthProvider>
    </CartProvider>
  );
}
